import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

export type AnalyticsErrorKind = { kind: 'generic' } | { kind: 'forbidden' } | { kind: 'badRequest'; message: string };

// Фаза 4: shared error state for all 7 Analytics screens. Only the generic case offers a retry -
// a network failure, a 5xx, or the screen's own 30s client-side timeout (see
// ANALYTICS_REQUEST_TIMEOUT_MS in analytics-request.util.ts) can all be retried by firing the
// exact same request again. 'forbidden' (403, assertNewAnalyticsEnabled - new Analytics not
// enabled for this client) and 'badRequest' (400, a request-level validation failure such as the
// 2-year range cap) are not transient, so a retry button would just fail the same way again - see
// classifyAnalyticsError in analytics-request.util.ts for how a caught error becomes one of these
// three. badRequest's message comes straight from the backend's own exception text (dynamic, not
// a fixed i18n key - it is already in English either way).
@Component({
	selector: 'app-analytics-error-state',
	standalone: true,
	imports: [MatIconModule, TranslateModule],
	templateUrl: './analytics-error-state.component.html',
})
export class AnalyticsErrorStateComponent {
	@Input({ required: true }) error!: AnalyticsErrorKind;
	@Output() retry = new EventEmitter<void>();
}
